import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    collapsed: { type: Boolean, default: false }
  };

  static targets = ["content", "icon"];

  toggle() {
    this.collapsedValue = !this.collapsedValue;
  }

  collapsedValueChanged() {
    if (this.collapsedValue) {
      this.contentTarget.classList.add("hidden");
      this.iconTarget.classList.add("-rotate-90");
    } else {
      this.contentTarget.classList.remove("hidden");
      this.iconTarget.classList.remove("-rotate-90");
    }
  }
}
